import React, { SVGProps } from "react"

export function IconAiAssistant(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 16 16"
      {...props}
    >
      <rect fill="currentColor" width="16" height="16" rx="2" />
      <path
        fill="#36244D"
        d="M7 3.5c.45 3.05 1.45 4.05 4.5 4.5-3.05.45-4.05 1.45-4.5 4.5-.45-3.05-1.45-4.05-4.5-4.5 3.05-.45 4.05-1.45 4.5-4.5ZM12 2c.15 1 .5 1.35 1.5 1.5-1 .15-1.35.5-1.5 1.5-.15-1-.5-1.35-1.5-1.5 1-.15 1.35-.5 1.5-1.5Z"
      />
    </svg>
  )
}
